<template>
  <div v-if="currentProfile && currentProfile.details">
    <!-- Titlebar
================================================== -->
    <div class="single-page-header freelancer-header">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="single-page-header-inner">
              <div class="left-side">
                <div class="header-image freelancer-avatar">
                  <img
                    v-if="currentProfile.details.avatar !== null"
                    :src="currentProfile.details.avatar"
                    alt=""
                  />
                  <span v-else class="freelancer-avatar__name">{{
                    currentProfile.details.name.substring(0, 2).toUpperCase()
                  }}</span>
                </div>
                <div class="header-details">
                  <h3> {{ currentProfile.details.name }} </h3>
                  <!-- <h3> {{ currentProfile.details.name }} <span>iOS Expert + Node Dev</span></h3> -->
                  <ul>
                    <li>
                      <div class="star-rating" :data-rating="`${currentProfile.details.ratings}.0`">
                        <span
                          class="star"
                          v-for="index in currentProfile.details.ratings"
                          :key="index"
                        ></span>

                        <span
                          class="star empty"
                          v-for="index in 5 - parseInt(currentProfile.details.ratings)"
                          :key="index"
                        ></span>
                      </div>
                    </li>
                    <li>
                      <i class="icon-material-outline-location-on"></i>
                      {{ currentProfile.details.country }}</li
                    >
                    <li><div class="verified-badge-with-title">Verified</div></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Page Content
================================================== -->
    <div class="container">
      <div class="row">
        <!-- Content -->
        <div class="col-xl-8 col-lg-8 content-right-offset">
          <!-- Page Content -->
          <div class="single-page-section">
            <h3 class="margin-bottom-25">About Me</h3>
            <p>{{
              currentProfile.details.bio !== null ? currentProfile.details.bio : 'No bio provided'
            }}</p>
          </div>

          <!-- Boxed List -->
          <div
            class="boxed-list margin-bottom-60"
            v-if="
              currentProfile.work_history_as_employer && currentProfile.work_history_as_employer.length
            "
          >
            <div class="boxed-list-headline">
              <h3><i class="icon-material-outline-business"></i> Employer Job History </h3>
            </div>
            <ul class="boxed-list-ul">
              <li
                v-for="(employer_history, index) in currentProfile.work_history_as_employer"
                :key="index"
              >
                <div class="boxed-list-item">
                  <!-- Content -->
                  <div class="item-content">
                    <h4>{{ employer_history.project_title }} <span>Rated as Employer</span></h4>
                    <div class="item-details margin-top-10">
                      <div
                        v-if="employer_history.rating !== null"
                        class="star-rating"
                        :data-rating="`${employer_history.rating}.0`"
                      >
                        <span
                          class="star"
                          v-for="rating in employer_history.rating"
                          :key="rating"
                        ></span>

                        <span
                          class="star empty"
                          v-for="rating in 5 - parseInt(employer_history.rating)"
                          :key="rating"
                        ></span>
                      </div>
                      <div v-else class="star-rating" data-rating="0.0">
                        <span class="star empty" v-for="rating in 5" :key="rating"></span>
                      </div>
                      <div class="detail-item"
                        ><i class="icon-material-outline-date-range"></i>
                        {{ formatDate(employer_history.created_at) }}</div
                      >
                    </div>
                    <div class="item-description">
                      <p>{{ employer_history.project_desc }} </p>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <!-- Boxed List / End -->

          <!-- Boxed List -->
          <div
            class="boxed-list margin-bottom-60"
            v-if="
              currentProfile.work_history_as_freelancer &&
                currentProfile.work_history_as_freelancer.length
            "
          >
            <div class="boxed-list-headline">
              <h3><i class="icon-material-outline-business"></i> Freelancer Job History </h3>
            </div>
            <ul class="boxed-list-ul">
              <li
                v-for="(freelancer_history, index) in currentProfile.work_history_as_freelancer"
                :key="index"
              >
                <div class="boxed-list-item">
                  <!-- Content -->
                  <div class="item-content">
                    <h4>{{ freelancer_history.project_title }} <span>Rated as Freelancer</span></h4>
                    <div class="item-details margin-top-10">
                      <div
                        v-if="freelancer_history.rating !== null"
                        class="star-rating"
                        :data-rating="`${freelancer_history.rating}.0`"
                      >
                        <span
                          class="star"
                          v-for="rating in freelancer_history.rating"
                          :key="rating"
                        ></span>

                        <span
                          class="star empty"
                          v-for="rating in 5 - parseInt(freelancer_history.rating)"
                          :key="rating"
                        ></span>
                      </div>
                      <div v-else class="star-rating" data-rating="0.0">
                        <span class="star empty" v-for="rating in 5" :key="rating"></span>
                      </div>
                      <div class="detail-item"
                        ><i class="icon-material-outline-date-range"></i>
                        {{ formatDate(freelancer_history.created_at) }}</div
                      >
                    </div>
                    <div class="item-description">
                      <p>{{ freelancer_history.project_desc }} </p>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <!-- Boxed List / End -->
        </div>

        <!-- Sidebar -->
        <div class="col-xl-4 col-lg-4">
          <div class="sidebar-container">
            <!-- Profile Overview -->

            <!-- Widget -->
            <div class="sidebar-widget">
              <h3>Social Profiles</h3>
              <div class="freelancer-socials margin-top-25">
                <ul>
                  <li
                    ><a href="#" title="LinkedIn" data-tippy-placement="top"
                      ><i class="icon-brand-linkedin"></i></a
                  ></li>
                </ul>
              </div>
            </div>

            <!-- Widget -->
            <div class="sidebar-widget">
              <h3>Skills</h3>
              <div class="task-tags">
                <span v-for="(skill, index) in currentProfile.skills" :key="index" class="mr-2">{{
                  skill.title
                }}</span>
              </div>
            </div>

            <!-- Sidebar Widget -->
            <div class="sidebar-widget">
              <h3>Share Profile</h3>

              <!-- Copy URL -->
              <div class="copy-url">
                <input id="copy-url" type="text" :value="pageUrl" class="with-border" />
                <button
                  @click="copyToClipboard()"
                  class="copy-url-button ripple-effect"
                  data-clipboard-target="#copy-url"
                  title="Copy to Clipboard"
                  data-tippy-placement="top"
                  ><i class="icon-material-outline-file-copy"></i
                ></button>
              </div>

              <!-- Share Buttons -->
              <!-- <div class="share-buttons margin-top-25">
                <div class="share-buttons-trigger"><i class="icon-feather-share-2"></i></div>
                <div class="share-buttons-content">
                  <span>Interesting? <strong>Share It!</strong></span>
                  <ul class="share-buttons-icons">
                    <li
                      ><a href="#" data-button-color="#3b5998" title="Share on Facebook" data-tippy-placement="top"
                        ><i class="icon-brand-facebook-f"></i></a
                    ></li>
                    <li
                      ><a href="#" data-button-color="#1da1f2" title="Share on Twitter" data-tippy-placement="top"
                        ><i class="icon-brand-twitter"></i></a
                    ></li>
                    <li
                      ><a href="#" data-button-color="#dd4b39" title="Share on Google Plus" data-tippy-placement="top"
                        ><i class="icon-brand-google-plus-g"></i></a
                    ></li>
                    <li
                      ><a href="#" data-button-color="#0077b5" title="Share on LinkedIn" data-tippy-placement="top"
                        ><i class="icon-brand-linkedin-in"></i></a
                    ></li>
                  </ul>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Spacer -->
    <div class="margin-top-15"></div>
    <!-- Spacer / End-->
  </div>
</template>

<script>
  /* eslint-disable no-console */
  import { getCall } from '../../../core/services/http.service';
  import { GET_USER_WITH_ID } from '../../../core/config/endpoints/user';
  import { formatDate } from '../../../plugins/handlers';
  import Snackbar from 'node-snackbar';
  
  export default {
    name: 'Profile',
    components: {},
    data() {
      return {
        currentProfile: {},
      };
    },
    methods: {
      getUserWithId() {
        this.$store.commit('setIsLoaded', true);
        getCall(GET_USER_WITH_ID.USER_ID(this.$route.query.id))
          .then((response) => {
            this.currentProfile = response.data.data;
          })
          .catch((error) => {
            if (parseInt(error.response.status) == 404) return this.$router.push({ name: 'NotFound' });
            this.$store.commit('setNotify', {
              type: 'error',
              message: error.response.data.message,
              status: true,
            });
          })
          .finally(() => {
            this.$store.commit('setIsLoaded', false);
          });
      },
      copyToClipboard() {
        Snackbar.show({
          text: 'Copied to clipboard!',
          pos: 'bottom-center',
          showAction: false,
          actionText: 'Dismiss',
          duration: 5000,
          textColor: '#fff',
          backgroundColor: '#383838',
        });
      },
      formatDate(dateTime) {
        return formatDate(dateTime);
      },
    },
    mounted: function() {
      this.getUserWithId();
    },
    computed: {
      pageUrl() {
        return window.location.href;
      },
    },
  };
</script>

<style scoped>
  .single-page-header.freelancer-header .header-image {
    justify-content: center;
    align-items: center;
  }
  .freelancer-avatar__name {
    font-size: 29px;
  }
</style>
